const LOG_LEVEL_COLORS = {
  DEBUG: '#5075DA',
  INFO: '#50DA7C',
  ERROR: '#DA6550',
  WARN: '#DAB250',
} as const;

type LogLevel = keyof typeof LOG_LEVEL_COLORS;

function log(level: LogLevel, ...rest: any[]): void {
  console.log(
    '%c[recapt]',
    `color:${LOG_LEVEL_COLORS[level]};font-weight:bold;`,
    ...rest,
  );
}

export function logDebug(enabled: boolean, ...rest: any[]): void {
  if (!enabled) return;
  log('DEBUG', ...rest);
}

export function logInfo(enabled: boolean, ...rest: any[]): void {
  if (!enabled) return;
  log('INFO', ...rest);
}

export function logWarn(enabled: boolean, ...rest: any[]): void {
  if (!enabled) return;
  log('WARN', ...rest);
}

export function logError(enabled: boolean, ...rest: any[]): void {
  if (!enabled) return;
  log('ERROR', ...rest);
}
